import Service from '../service.js';
import UploadImage from '@/components/upload-image/index.vue';
import SelectBankCode from '@/components/select-bank-code/index.vue';
import { successMessage, errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
const debounce = require('lodash.debounce');

export default {
  components: {
    UploadImage,
    SelectBankCode
  },
  data() {
    return {
      images: [],
      form: {
        accName: '',
        accBankCardNo: '',
        bankName: '',
        bankCode: '',
        mobile: '',
        licensePath: []
      },
      defaultImage: [],
      dialogVisible: false,
      bankCodeDisFlag: true,
      rules: {
        accName: [
          { required: true, message: '请输入开户名称', trigger: 'blur'}
        ],
        accBankCardNo: [
          { required: true, message: '请输入银行账号', trigger: 'blur'}
        ],
        bankName: [
          { required: true, message: '请输入开户银行', trigger: 'blur'}
        ],
        bankCode: [
          { required: true, message: '请输入开户银行联行号', trigger: 'blur'}
        ],
        mobile: [
          { required: true, message: '请输入预留手机号', trigger: 'blur'}
        ],
        licensePath: [
          { required: true, message: '请上传开户许可证', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'isHeilongjiang']),
    disabledEdit() {
      if (this.isHeilongjiang && this.userInfo.type === 3) {
        return false;
      }
      if (!this.form.bankId) {
        return false;
      }
      return true;
    }
  },
  created () {
    console.log(this.userInfo);
    this.form.bankId = this.$route.query.bankId;
    this.form.accName = this.userInfo.username;
    this.form.mobile = this.userInfo.mobile;
    // 个人用户
    if(Number(this.userInfo.type) === 1) {
      this.rules.licensePath = [
        { required: true, message: '请上传银行卡照片', trigger: 'blur' }
      ];
    } else {
      // 非个人不传手机号
      delete this.form.mobile;
    }
    this.form.bankId && this.getBankDetail();
  },
  methods: {
    getBankDetail(){
      Service.getBankDetail(this.form.bankId).then(({code, data}) => {
        if (code === '0') {
          Object.keys(this.form).forEach(key => {
            if(data[key]) {
              this.form[key] = data[key];
            }
          });
          data.list.forEach(image => {
            this.form.licensePath.push(image.fullPath);
            this.defaultImage = image.allPath;
          });
          this.images = data.list.map(item => {
            return {
              url: item.allPath
            };
          });
        }
      });
    },
    // 返回
    goBack () {
      this.$router.push('/person-center/account-info/bank-account-manage/list');
    },
    searchBankCode() {
      // 至少四位才能查询
      if (this.form.bankName && this.form.bankName.length >= 4) {
        this.dialogVisible = true;
      }
    },
    changeInfo(bankInfo) {
      if(bankInfo) {
        this.form.bankName = bankInfo.bankName;
        this.form.bankCode = bankInfo.correspondNumber;
        this.bankCodeDisFlag = true;
      } else {
        this.form.bankName = '';
        this.form.bankCode = '';
        this.bankCodeDisFlag = false;
      }
    },
    uploadImage (event) {
      if(event.length > 0) {
        this.form.licensePath[0] = event[0].sourceImgUrl;
      } else {
        this.form.licensePath = [];
      }
    },
    // 提交信息
    addBankInfo: debounce(function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          // this.$store.commit('OPEN_LOADING');
          let interfaceName = this.form.bankId ? 'updateBankInfo' : 'addBankInfo';
          Service[interfaceName](this.form).then(res => {
            if (res && res.code === '0') {
              successMessage('提交成功');
              this.$router.push('/person-center/account-info/bank-account-manage/list');
            } else {
              errorMessage(res && res.reason);
            }
          }, (error) => {
            if (error && error.data && error.data.reason) {
              errorMessage(error.data.reason);
            }
          });
        };
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
